import { Square, MovementSquare } from "../model/square.js";

export let path = [];

let coordinates = [
  [195, 830],
  [263, 815],
  [308, 808],
  [353, 802],
  [403, 805],
  [452, 808],
  [500, 816],
  [548, 830],
  [595, 846],
  [644, 842],
  [651, 795],
  [622, 752],
  [590, 714],
  [550, 686],
  [506, 664],
  [459, 662],
  [409, 665],
  [357, 671],
  [314, 676],
  [260, 685],
  [214, 690],
  [164, 695],
  [119, 675],
  [112, 627],
  [139, 584],
  [179, 559],
  [231, 549],
  [280, 545],
  [328, 546],
  [375, 550],
  [426, 555],
  [472, 553],
  [524, 552],
  [567, 542],
  [616, 521],
  [612, 475],
  [584, 433],
  [553, 394],
  [556, 343],
  [598, 312],
  [634, 286],
  [629, 238],
  [591, 204],
  [542, 199],
  [496, 220],
  [458, 253],
  [423, 286],
  [396, 331],
  [410, 377],
  [427, 427],
  [377, 443],
  [328, 437],
  [279, 419],
  [232, 408],
  [189, 382],
  [153, 350],
  [130, 304],
  [119, 256],
  [146, 214],
  [188, 197],
  [238, 192],
  [287, 193],
  [335, 190],
  [378, 175],
  [429, 125],
];

for (let i = 0; i <= 64; i++){
  if ([6, 18, 30, 42, 54].includes(i)){
    path.push(new Square(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "magic-x2"));
  }
  else if ([12, 24, 36, 48, 60].includes(i)){
    path.push(new Square(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "magic-x3"));
  }
  else if ([3, 15, 21, 33, 39, 45, 51, 57].includes(i)){
    path.push(new Square(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "bonus"));
  }
  else{
    path.push(new Square(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "basic"));
  }
}

// path.push(new Square(0, new Phaser.Math.Vector2(80, 760), "basic"));
// path.push(new Square(1, new Phaser.Math.Vector2(150, 760), "basic"));
// path.push(new Square(2, new Phaser.Math.Vector2(215, 760), "basic"));
// path.push(new Square(3, new Phaser.Math.Vector2(280, 760), "basic"));
// path.push(new Square(4, new Phaser.Math.Vector2(355, 760), "basic"));
// path.push(
//   new MovementSquare(5, new Phaser.Math.Vector2(415, 760), "movement", 33)
// );
// path.push(new Square(6, new Phaser.Math.Vector2(485, 760), "magic-x2"));
// path.push(new Square(7, new Phaser.Math.Vector2(555, 760), "basic"));
// path.push(new Square(8, new Phaser.Math.Vector2(625, 760), "basic"));
// path.push(new Square(9, new Phaser.Math.Vector2(690, 760), "basic"));

// path.push(
//   new MovementSquare(10, new Phaser.Math.Vector2(690, 700), "movement", 48)
// );
// path.push(new Square(11, new Phaser.Math.Vector2(625, 700), "basic"));
// path.push(new Square(12, new Phaser.Math.Vector2(555, 700), "magic-x3"));
// path.push(new Square(13, new Phaser.Math.Vector2(485, 700), "basic"));
// path.push(new Square(14, new Phaser.Math.Vector2(415, 700), "basic"));
// path.push(new Square(15, new Phaser.Math.Vector2(355, 700), "basic"));
// path.push(new Square(16, new Phaser.Math.Vector2(280, 700), "basic"));
// path.push(new Square(17, new Phaser.Math.Vector2(215, 700), "basic"));
// path.push(
//   new MovementSquare(18, new Phaser.Math.Vector2(150, 700), "movement", 3)
// );
// path.push(
//   new MovementSquare(19, new Phaser.Math.Vector2(80, 700), "movement", 37)
// );

// path.push(new Square(20, new Phaser.Math.Vector2(80, 630), "basic"));
// path.push(new Square(21, new Phaser.Math.Vector2(150, 630), "basic"));
// path.push(new Square(22, new Phaser.Math.Vector2(215, 630), "basic"));
// path.push(new Square(23, new Phaser.Math.Vector2(280, 630), "basic"));
// path.push(new Square(24, new Phaser.Math.Vector2(355, 630), "magic-x2"));
// path.push(new Square(25, new Phaser.Math.Vector2(415, 630), "basic"));
// path.push(new Square(26, new Phaser.Math.Vector2(485, 630), "basic"));
// path.push(new Square(27, new Phaser.Math.Vector2(555, 630), "basic"));
// path.push(new Square(28, new Phaser.Math.Vector2(625, 630), "basic"));
// path.push(new Square(29, new Phaser.Math.Vector2(690, 630), "basic"));

// path.push(new Square(30, new Phaser.Math.Vector2(690, 560), "basic"));
// path.push(new Square(31, new Phaser.Math.Vector2(625, 560), "basic"));
// path.push(new Square(32, new Phaser.Math.Vector2(555, 560), "magic-x3"));
// path.push(new Square(33, new Phaser.Math.Vector2(485, 560), "basic"));
// path.push(new Square(34, new Phaser.Math.Vector2(415, 560), "basic"));
// path.push(new Square(35, new Phaser.Math.Vector2(355, 560), "basic"));
// path.push(new Square(36, new Phaser.Math.Vector2(280, 560), "basic"));
// path.push(new Square(37, new Phaser.Math.Vector2(215, 560), "basic"));
// path.push(new Square(38, new Phaser.Math.Vector2(150, 560), "basic"));
// path.push(new Square(39, new Phaser.Math.Vector2(80, 560), "magic-x2"));

// path.push(new Square(40, new Phaser.Math.Vector2(80, 490), "basic"));
// path.push(new Square(41, new Phaser.Math.Vector2(150, 490), "basic"));
// path.push(new Square(42, new Phaser.Math.Vector2(215, 490), "basic"));
// path.push(
//   new MovementSquare(43, new Phaser.Math.Vector2(280, 490), "movement", 65)
// );
// path.push(new Square(44, new Phaser.Math.Vector2(355, 490), "basic"));
// path.push(
//   new MovementSquare(45, new Phaser.Math.Vector2(415, 490), "movement", 36)
// );
// path.push(new Square(46, new Phaser.Math.Vector2(485, 490), "basic"));
// path.push(new Square(47, new Phaser.Math.Vector2(555, 490), "basic"));
// path.push(new Square(48, new Phaser.Math.Vector2(625, 490), "basic"));
// path.push(new Square(49, new Phaser.Math.Vector2(690, 490), "magic-x3"));

// path.push(new Square(50, new Phaser.Math.Vector2(690, 420), "basic"));
// path.push(new Square(51, new Phaser.Math.Vector2(625, 420), "basic"));
// path.push(new Square(52, new Phaser.Math.Vector2(555, 420), "basic"));
// path.push(new Square(53, new Phaser.Math.Vector2(485, 420), "magic-x2"));
// path.push(new Square(54, new Phaser.Math.Vector2(415, 420), "basic"));
// path.push(new Square(55, new Phaser.Math.Vector2(355, 420), "basic"));
// path.push(new Square(56, new Phaser.Math.Vector2(280, 420), "basic"));
// path.push(
//   new MovementSquare(57, new Phaser.Math.Vector2(215, 420), "movement", 79)
// );
// path.push(new Square(58, new Phaser.Math.Vector2(150, 420), "basic"));
// path.push(
//   new MovementSquare(59, new Phaser.Math.Vector2(80, 420), "movement", 42)
// );

// path.push(new Square(60, new Phaser.Math.Vector2(80, 360), "basic"));
// path.push(new Square(61, new Phaser.Math.Vector2(150, 360), "basic"));
// path.push(new Square(62, new Phaser.Math.Vector2(215, 360), "basic"));
// path.push(new Square(63, new Phaser.Math.Vector2(280, 360), "basic"));
// path.push(new Square(64, new Phaser.Math.Vector2(355, 360), "basic"));
// path.push(new Square(65, new Phaser.Math.Vector2(415, 360), "basic"));
// path.push(new Square(66, new Phaser.Math.Vector2(485, 360), "basic"));
// path.push(
//   new MovementSquare(67, new Phaser.Math.Vector2(555, 360), "movement", 50)
// );
// path.push(new Square(68, new Phaser.Math.Vector2(625, 360), "basic"));
// path.push(new Square(69, new Phaser.Math.Vector2(690, 360), "magic-x2"));

// path.push(new Square(70, new Phaser.Math.Vector2(690, 285), "basic"));
// path.push(new Square(71, new Phaser.Math.Vector2(625, 285), "basic"));
// path.push(new Square(72, new Phaser.Math.Vector2(555, 285), "basic"));
// path.push(
//   new MovementSquare(73, new Phaser.Math.Vector2(485, 285), "movement", 90)
// );
// path.push(new Square(74, new Phaser.Math.Vector2(415, 285), "basic"));
// path.push(new Square(75, new Phaser.Math.Vector2(355, 285), "basic"));
// path.push(new Square(76, new Phaser.Math.Vector2(280, 285), "magic-x3"));
// path.push(new Square(77, new Phaser.Math.Vector2(215, 285), "basic"));
// path.push(new Square(78, new Phaser.Math.Vector2(150, 285), "basic"));
// path.push(new Square(79, new Phaser.Math.Vector2(80, 285), "basic"));

// path.push(new Square(80, new Phaser.Math.Vector2(80, 220), "basic"));
// path.push(new Square(81, new Phaser.Math.Vector2(150, 220), "basic"));
// path.push(new Square(82, new Phaser.Math.Vector2(215, 220), "basic"));
// path.push(new Square(83, new Phaser.Math.Vector2(280, 220), "basic"));
// path.push(
//   new MovementSquare(84, new Phaser.Math.Vector2(355, 220), "movement", 97)
// );
// path.push(new Square(85, new Phaser.Math.Vector2(415, 220), "basic"));
// path.push(new Square(86, new Phaser.Math.Vector2(485, 220), "basic"));
// path.push(new Square(87, new Phaser.Math.Vector2(555, 220), "basic"));
// path.push(new Square(88, new Phaser.Math.Vector2(625, 220), "basic"));
// path.push(new Square(89, new Phaser.Math.Vector2(690, 220), "magic-x3"));

// path.push(new Square(90, new Phaser.Math.Vector2(690, 155), "basic"));
// path.push(new Square(91, new Phaser.Math.Vector2(625, 155), "basic"));
// path.push(new Square(92, new Phaser.Math.Vector2(555, 155), "basic"));
// path.push(
//   new MovementSquare(93, new Phaser.Math.Vector2(485, 155), "movement", 74)
// );
// path.push(new Square(94, new Phaser.Math.Vector2(415, 155), "basic"));
// path.push(new Square(95, new Phaser.Math.Vector2(355, 155), "magic-x2"));
// path.push(new Square(96, new Phaser.Math.Vector2(280, 155), "basic"));
// path.push(new Square(97, new Phaser.Math.Vector2(215, 155), "basic"));
// path.push(new Square(98, new Phaser.Math.Vector2(150, 155), "basic"));
// path.push(new Square(99, new Phaser.Math.Vector2(80, 155), "basic"));
